import { useParams } from "react-router-dom";
import EditLayout from "../EditLayout";
import PixelTable from "@/pages/EditProduct/Pixels/Partials/PixelTable.tsx";

export default function Pixels() {
  const { id } = useParams<{ id: string }>();
  
  return (
    <>
      <div className='flex items-center justify-center h-full'>
        <PixelTable productId={id} />
      </div>
    </>
  );
}
